import { Component, inject } from '@angular/core';
import { AuthService, BlockAbstractComponent, PageService, ParserService } from '@gallaghercp/core-frontend';

@Component({
  selector: 'core-block-h1-title',
  template: ` @if (block.data.text) {
    <h1 [attr.id]="block.data.anchorId ?? 'block--' + block.uid" tabindex="0" [innerText]="block.data.text"></h1>
    <!-- Having the tags visible is not part of UHS's design, remove/hide -->
    <!--  <div *ngIf="tags.length > 0" class="mb-3"> -->
    <!--      <core-block-tags [tags]="tags" [zone]="zone" [enableLinks]="true"></core-block-tags> -->
    <!--  </div> -->
  }`,
  standalone: false,
})
export class BlockH1TitleComponent extends BlockAbstractComponent {
  protected override auth: AuthService;
  protected override parser: ParserService;
  protected override pages: PageService;

  tags!: string[];
  zone!: number;

  constructor() {
    const auth = inject(AuthService);
    const parser = inject(ParserService);
    const pages = inject(PageService);

    super(parser, auth, pages);

    this.auth = auth;
    this.parser = parser;
    this.pages = pages;
  }

  override ngOnInit() {
    super.ngOnInit();

    const tagsFromService = this.translateService.getPageSpecific(this.pages.getCurrentPage(), 'tags');
    this.tags =
      tagsFromService && tagsFromService.length > 0 ? tagsFromService : (this.pages.getCurrentPage().tags ?? []);

    this.zone = this.pages.getCurrentPage().zone ?? 0;

    if (this.pages.getCurrentPage()) {
      this.block.data.text = this.translateService.getPageSpecific(this.pages.getCurrentPage(), 'name');
    }
  }
}
